import { render, staticRenderFns } from "./Painel.vue?vue&type=template&id=1e891aef&scoped=true&"
import script from "./Painel.vue?vue&type=script&lang=js&"
export * from "./Painel.vue?vue&type=script&lang=js&"
import style0 from "./Painel.vue?vue&type=style&index=0&id=1e891aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e891aef",
  null
  
)

export default component.exports